import { render } from "./PrivacyOtherBusiness.vue?vue&type=template&id=791e7f4e"
const script = {}

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__